import Api from "../../axios"

export const getViewFeedback= async ({id})=>{
    return await Api.get(`/employee_feedback_view?feedback_id=${id}`)
}